/**
 * Analytics Portal V1 — Events Analytics (Phase 14, plan §4.6 + §11 endpoint 7).
 * A pure renderer of `GET /api/analytics/event` through the shared entity dashboard, plus the
 * Event-only timing insights section.
 */
import React from "react";
import { EntityDashboard } from "@/components/analytics/EntityDashboard";
import { EventTimingCard } from "@/components/analytics/EventTimingCard";
import { EVENT_GROUPS, EVENT_HEADLINE } from "@/components/analytics/eventsMetrics";
import { useAnalyticsPortal } from "./AnalyticsPortal";

export default function EventsTab() {
  const portal = useAnalyticsPortal();
  const payload = portal?.payload;

  return (
    <EntityDashboard
      portal={portal}
      testId="analytics-view-events"
      scopeType="event"
      headline={EVENT_HEADLINE}
      groups={EVENT_GROUPS}
      funnelTitle="Event conversion funnel"
      noActivityBody="This event's analytics will populate once eligible activity is collected."
      afterGroups={payload && (
        <EventTimingCard timing={payload.timing}
                         rangeSuggestion={payload.range_suggestion}
                         onUseSupportedRange={portal.onUseSupportedRange} />
      )}
    />
  );
}
